export enum SongsAvailability {
  Undecided = 0, //The application did not yet try
  ToCIsAvailable, //The application was able to fetch the table of contents, either online or offline
  NotAuthenticated, //The ToC could not be received due to missing bearer token (user not logged in at all)
  InsufficientPermissions, //The ToC could not be received due to insufficient permissions
  ToCNotAvailable, //The application is not able to connect to the server and no toc was found in the cache
  RedirectToLoginNecessary, //User needs to login and is therefore being redirected
}
